import React, { Component } from 'react';
import { store } from './stores/mainStore';
import { observer } from 'mobx-react';

import { Main } from './components/Main';
import { CommandQueue } from './webview/CommandQueue'
import {Const} from './stores/Constants';
import {Manager} from './game/manager';
import {Gleam} from './webview/Gleam';

@observer
class App extends Component {
	constructor(){
		super();
		window.store = store;
		if (process.env.NODE_ENV === 'production') {  
			console.log('******** ABOUT TO DISABLE CONSOLE.LOG ********');
			console.log = function() {};
			console.log('***** trying to log after disable.  IF YOU SEE THIS LOGGING IS ENABLED');
		}

		window.CommandQueue = new CommandQueue(window.CommandQueue);

		window.manager = null;
		window.manager = new Manager();

		// load config
		[{config: Const.gleamConfig, func: Gleam.checkPromos}].map(v => {
			return fetch(v.config)
				.then(res => res.text())
				.then(d => v.func(JSON.parse(d), Const.remotePath))
		})
		/* // check region
		fetch('https://api.ipstack.com/check?access_key=897ba834be1aa56497ac3f62921b631b')
		.then((response) => {
			response.json().then((data) => { 
				window.manager.region = data.region_code || 'n/a';
				if(window.manager.region === window.manager.disallowedRegion) {
					store.modal = 'regionNotAllowed';
				}
			});
		}).then(() => {		// load configs
			const arr = [
				{config: Const.promoConfig, func: store.setPromos},
				{config: Const.weekConfig, func: store.setWeekPromos},
			]
			return Promise.all(arr.map(v => {
				return fetch(v.config)
					.then(res => res.text())
					.then(d => v.func(JSON.parse(d), Const.remotePath))
			}))
		}).catch((err) => { console.error('Region error') });
		 */
	}
	render() {
		return <Main/>
	}
}
export { App };
